import { render, staticRenderFns } from "./Sinamed.vue?vue&type=template&id=02febd54"
import script from "./Sinamed.vue?vue&type=script&lang=js"
export * from "./Sinamed.vue?vue&type=script&lang=js"
import style0 from "./Sinamed.vue?vue&type=style&index=0&id=02febd54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports